import { render, staticRenderFns } from "./SettingsControl.vue?vue&type=template&id=551a9bac&scoped=true&"
import script from "./SettingsControl.vue?vue&type=script&lang=js&"
export * from "./SettingsControl.vue?vue&type=script&lang=js&"
import style0 from "./SettingsControl.vue?vue&type=style&index=0&id=551a9bac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a9bac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VRangeSlider,VSelect,VSlider,VSwitch,VTextField})
